import React, { useEffect } from 'react';

import EventHeader from './EventHeader/EventHeader';
import KpiStrip from './KpiStrip/KpiStrip';
import SalesPerformance from './SalesPerformance/SalesPerformance';
import AudienceInsights from '../../../shared/marketing/AudienceInsights';
import BuyerLocationCard from '../../../shared/marketing/BuyerLocationCard';
import TrafficConversionCard from '../../../shared/marketing/TrafficConversionCard';
import SourcesLinksCard from '../../../shared/marketing/SourcesLinksCard';
import ComparableEvents from '../../../shared/marketing/ComparableEvents';
import EventMessages from '../../../shared/marketing/EventMessages';
import { useMarketingInsightsContext } from '../context/MarketingInsightsContext';

import '../../../shared/marketing/marketingShared.css';
import './shared/SectionStub.css';

// ponytail: re-scrolls for a few seconds while async cards above the target load and shift it; stops on any user scroll.
export const useScrollToHashWhileLoading = (settleMs = 4000) => {
  useEffect(() => {
    let id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch {
      return undefined;
    }
    if (!id) return undefined;

    const stopEvents = ['wheel', 'touchstart', 'keydown'];
    const stop = () => {
      clearInterval(timer);
      stopEvents.forEach((name) => window.removeEventListener(name, stop));
    };
    const timer = setInterval(() => document.getElementById(id)?.scrollIntoView({ block: 'start' }), 250);
    const deadline = setTimeout(stop, settleMs);
    stopEvents.forEach((name) => window.addEventListener(name, stop, { passive: true }));
    return () => { stop(); clearTimeout(deadline); };
  }, [settleMs]);
};

const MarketingInsights = () => {
  const ctx = useMarketingInsightsContext();
  useScrollToHashWhileLoading();
  const confirm = {
    id: ctx.id,
    name: ctx.name,
    start_time: ctx.start_time,
    state_label: ctx.state_label,
    venue_name: ctx.venue_name,
    city: ctx.city,
    state_code: ctx.state_code,
    capacity: ctx.capacity,
    age_restriction: ctx.age_restriction,
    contact_name: ctx.contact_name,
    promoter_name: ctx.promoter_name,
    tags: ctx.tags,
  };

  return (
    <div className="marketing-insights-root">
      <div className="mi-page">
        <EventHeader confirm={confirm} timeZone={ctx.time_zone} />
        <KpiStrip kpis={ctx.kpis} />
        <SalesPerformance
          salesData={ctx.sales_data}
          cumulativeSalesData={ctx.cumulative_sales_data}
          forecastCurve={ctx.forecast_curve}
          forecastRationale={ctx.forecast_rationale}
          capacity={ctx.kpis?.capacity}
          todayDate={ctx.today_date}
        />
        <AudienceInsights teamId={ctx.team?.id} confirmId={ctx.id} venueName={ctx.venue_name} sectionNumber={3} />
        <BuyerLocationCard teamId={ctx.team?.id} confirmId={ctx.id} />
        <TrafficConversionCard teamId={ctx.team?.id} confirmId={ctx.id} attributionWindowDays={ctx.team?.attribution_window_days} viewsConversion={ctx.views_conversion} sourcePerformance={ctx.source_performance} sectionNumber={4} />
        <SourcesLinksCard
          teamId={ctx.team?.id}
          confirmId={ctx.id}
          csrfToken={ctx.csrfToken}
          trackableRows={ctx.trackable_rows}
          leftoverRows={ctx.leftover_rows}
          referringSiteRows={ctx.referring_site_rows}
          paidRows={ctx.paid_rows}
          trackableLinks={ctx.trackable_links}
          ticketTypeOptions={ctx.ticket_type_options}
          websiteUrl={ctx.website_url}
          trackingSince={ctx.tracking_since}
        />
        <EventMessages teamId={ctx.team?.id} confirmId={ctx.id} />
        <ComparableEvents teamId={ctx.team?.id} confirmId={ctx.id} sectionNumber={5} />
      </div>
    </div>
  );
};

export default MarketingInsights;
